import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useRef } from "react";
import { Button, ButtonGroup, DropdownButton, Dropdown } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { getActionQoDisplay, isDisabledEditQo } from "utils/HelperQoFunction";
import { PrintQO } from "./PrintQO";
import { useReactToPrint } from "react-to-print";
export default function QoFooterSubmit(param) {
    var setFieldValue = param.setFieldValue, setModalNotApprove = param.setModalNotApprove, values = param.values, formdisabled = param.formdisabled, setFormdisabled = param.setFormdisabled, companyInfo = param.companyInfo, options = param.options, setProductRow = param.setProductRow;
    var navigate = useNavigate();
    var componentRef = useRef();
    var handlePrint = useReactToPrint({
        content: function() {
            return componentRef.current;
        }
    });
    return /*#__PURE__*/ _jsx("div", {
        className: "card pagezoom card-st-3  mb-4 fixed bottom-0 w-[calc(100%-110px)] drop-shadow",
        style: {
            minWidth: "1000px"
        },
        children: /*#__PURE__*/ _jsxs("div", {
            className: "card-body px-xl-3 d-flex justify-between",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "flex",
                    children: getActionQoDisplay({
                        formdisabled: formdisabled,
                        dimMstNewStatus: values.dimMstQoStatus
                    }).statusPrint && /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                style: {
                                    display: "none"
                                },
                                children: /*#__PURE__*/ _jsx(PrintQO, {
                                    innerRef: componentRef,
                                    values: values,
                                    companyInfo: companyInfo
                                })
                            }),
                            /*#__PURE__*/ _jsxs(Button, {
                                onClick: handlePrint,
                                type: "button",
                                className: "btn-st-8 fs-14 border-0 px-3 me-3",
                                children: [
                                    /*#__PURE__*/ _jsx("i", {
                                        className: "iprinter"
                                    }),
                                    "พิมพ์เอกสาร"
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx(Button, {
                    type: "button",
                    onClick: function(e) {
                        navigate("/sale/quotation");
                    },
                    className: "btn-st-6 me-3 btn ms-auto",
                    children: "ยกเลิก"
                }),
                getActionQoDisplay({
                    formdisabled: formdisabled,
                    dimMstNewStatus: values.dimMstQoStatus
                }).status1 && /*#__PURE__*/ _jsx(Button, {
                    type: "submit",
                    onClick: function(e) {
                        var _options_branch, _options_warehouse;
                        // e.preventDefault();
                        setFieldValue("dim_mst_qo_status_id", 1);
                        // Auto-set dim_branch_id if empty
                        if (!values.dim_branch_id && (options === null || options === void 0 ? void 0 : (_options_branch = options.branch) === null || _options_branch === void 0 ? void 0 : _options_branch.length) > 0) {
                            setFieldValue("dim_branch_id", options.branch[0].value);
                        }
                        // Auto-set dim_warehouse_id if empty
                        if (!values.dim_warehouse_id && (options === null || options === void 0 ? void 0 : (_options_warehouse = options.warehouse) === null || _options_warehouse === void 0 ? void 0 : _options_warehouse.length) > 0) {
                            setFieldValue("dim_warehouse_id", options.warehouse[0].value);
                            setProductRow === null || setProductRow === void 0 ? void 0 : setProductRow(function(prev) {
                                return prev.map(function(row) {
                                    return _object_spread_props(_object_spread({}, row), {
                                        warehouseID: options.warehouse[0].value,
                                        warehouseName: options.warehouse[0].label
                                    });
                                });
                            });
                        }
                    },
                    className: "btn-st-3 me-3",
                    children: "บันทึกร่าง"
                }),
                formdisabled && /*#__PURE__*/ _jsx(Button, {
                    type: "button",
                    onClick: function() {
                        setFormdisabled(false);
                    },
                    className: "btn-st-3 me-3 ".concat(isDisabledEditQo({
                        dimMstNewStatus: values.dimMstQoStatus
                    }) ? "lock-btn" : ""),
                    disabled: isDisabledEditQo({
                        dimMstNewStatus: values.dimMstQoStatus
                    }),
                    children: "แก้ไข"
                }),
                getActionQoDisplay({
                    formdisabled: formdisabled,
                    dimMstNewStatus: values.dimMstQoStatus
                }).status2 && /*#__PURE__*/ _jsxs(ButtonGroup, {
                    className: " btn-group-st-1 ",
                    children: [
                        getActionQoDisplay({
                            formdisabled: formdisabled,
                            dimMstNewStatus: values.dimMstQoStatus
                        }).status2_1 && /*#__PURE__*/ _jsx(Button, {
                            type: "submit",
                            onClick: function(e) {
                                var _options_branch, _options_warehouse;
                                // e.preventDefault();
                                setFieldValue("dim_mst_qo_status_id", 2);
                                // Auto-set dim_branch_id if empty
                                if ((options === null || options === void 0 ? void 0 : (_options_branch = options.branch) === null || _options_branch === void 0 ? void 0 : _options_branch.length) === 1) {
                                    setFieldValue("dim_branch_id", 1);
                                }
                                // Auto-set dim_warehouse_id if empty
                                if ((options === null || options === void 0 ? void 0 : (_options_warehouse = options.warehouse) === null || _options_warehouse === void 0 ? void 0 : _options_warehouse.length) === 1) {
                                    setFieldValue("dim_warehouse_id", 1);
                                    setProductRow === null || setProductRow === void 0 ? void 0 : setProductRow(function(prev) {
                                        return prev.map(function(row) {
                                            return _object_spread_props(_object_spread({}, row), {
                                                warehouseID: 1,
                                                warehouseName: options.warehouse[0].label
                                            });
                                        });
                                    });
                                }
                            },
                            children: "ส่งอนุมัติ"
                        }),
                        getActionQoDisplay({
                            formdisabled: formdisabled,
                            dimMstNewStatus: values.dimMstQoStatus
                        }).status4 && /*#__PURE__*/ _jsx(Button, {
                            type: "submit",
                            onClick: function() {
                                var _options_branch, _options_warehouse;
                                setFieldValue("dim_mst_qo_status_id", 3);
                                // Auto-set dim_branch_id if empty
                                if ((options === null || options === void 0 ? void 0 : (_options_branch = options.branch) === null || _options_branch === void 0 ? void 0 : _options_branch.length) === 1) {
                                    setFieldValue("dim_branch_id", 1);
                                }
                                // Auto-set dim_warehouse_id if empty
                                if ((options === null || options === void 0 ? void 0 : (_options_warehouse = options.warehouse) === null || _options_warehouse === void 0 ? void 0 : _options_warehouse.length) === 1) {
                                    setFieldValue("dim_warehouse_id", 1);
                                    setProductRow === null || setProductRow === void 0 ? void 0 : setProductRow(function(prev) {
                                        return prev.map(function(row) {
                                            return _object_spread_props(_object_spread({}, row), {
                                                warehouseID: 1,
                                                warehouseName: options.warehouse[0].label
                                            });
                                        });
                                    });
                                }
                            },
                            children: "อนุมัติ"
                        }),
                        getActionQoDisplay({
                            formdisabled: formdisabled,
                            dimMstNewStatus: values.dimMstQoStatus
                        }).status5 && /*#__PURE__*/ _jsx(Button, {
                            className: "w-100",
                            onClick: function() {
                                return setModalNotApprove(function(prev) {
                                    return _object_spread_props(_object_spread({}, prev), {
                                        open: true
                                    });
                                });
                            },
                            children: "ไม่อนุมัติ"
                        }),
                        getActionQoDisplay({
                            formdisabled: formdisabled,
                            dimMstNewStatus: values.dimMstQoStatus
                        }).statusDropdown4 && /*#__PURE__*/ _jsxs(DropdownButton, {
                            as: ButtonGroup,
                            title: "",
                            id: "bg-nested-dropdown",
                            children: [
                                getActionQoDisplay({
                                    formdisabled: formdisabled,
                                    dimMstNewStatus: values.dimMstQoStatus
                                }).statusDropdown4_1 && /*#__PURE__*/ _jsx(Button, {
                                    type: "submit",
                                    onClick: function() {
                                        var _options_branch, _options_warehouse;
                                        setFieldValue("dim_mst_qo_status_id", 3);
                                        // Auto-set dim_branch_id if empty
                                        if ((options === null || options === void 0 ? void 0 : (_options_branch = options.branch) === null || _options_branch === void 0 ? void 0 : _options_branch.length) === 1) {
                                            setFieldValue("dim_branch_id", 1);
                                        }
                                        // Auto-set dim_warehouse_id if empty
                                        if ((options === null || options === void 0 ? void 0 : (_options_warehouse = options.warehouse) === null || _options_warehouse === void 0 ? void 0 : _options_warehouse.length) === 1) {
                                            setFieldValue("dim_warehouse_id", 1);
                                            setProductRow === null || setProductRow === void 0 ? void 0 : setProductRow(function(prev) {
                                                return prev.map(function(row) {
                                                    return _object_spread_props(_object_spread({}, row), {
                                                        warehouseID: 1,
                                                        warehouseName: options.warehouse[0].label
                                                    });
                                                });
                                            });
                                        }
                                    },
                                    children: "อนุมัติ"
                                }),
                                getActionQoDisplay({
                                    formdisabled: formdisabled,
                                    dimMstNewStatus: values.dimMstQoStatus
                                }).statusDropdown5 && /*#__PURE__*/ _jsx(Button, {
                                    className: "w-100",
                                    onClick: function() {
                                        return setModalNotApprove(function(prev) {
                                            return _object_spread_props(_object_spread({}, prev), {
                                                open: true
                                            });
                                        });
                                    },
                                    children: "ไม่อนุมัติ"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
